<template>
  <layout-full-width :title="$tc('dashboard', 1)">

    <div class="row" v-if="!loading">
      <div class="col-sm-12 col-lg-4">
        <div class="card">
          <div class="card-header">{{ $t('projectHistory', { year: '' }) }}</div>
          <div class="card-body">
            <label for="chart-data-year" class="sr-only form-label">{{ $tc('year', 1) }}</label>
            <select id="chart-data-year" class="mb-3 form-select" v-model="year">
              <option v-for="(data, year) in this.statistic"
                      :value="parseInt(year)"
                      :key="'chart-data-year-' + year">
                {{ year }}
              </option>
            </select>
            <component-project-history-chart id="projects-histogram"
                                             style="width: 100%;"
                                             :chart-data="this.chartData"
                                             :options="this.chartOptions"/>
          </div>
        </div>
      </div>
    </div>
    <component-spinner v-if="loading" class="p-5"/>
  </layout-full-width>
</template>

<script>
import LayoutFullWidth from "@/layouts/LayoutFullWidth";
import ComponentSpinner from "@/components/ui/ComponentSpinner";
import ComponentProjectHistoryChart from "@/components/ComponentProjectHistoryChart";
import i18n from "@/i18n";

export default {
  name: "PageDashboard",
  components: { ComponentProjectHistoryChart, LayoutFullWidth, ComponentSpinner },
  data() {
    return {
      loading: true,
      year: new Date().getFullYear()
    }
  },
  computed: {
    chartData() {
      let graphData = [];
      const statistic = this.statistic;
      const year = this.year;
      const labels = [
        i18n.t('months.january'),
        i18n.t('months.february'),
        i18n.t('months.march'),
        i18n.t('months.april'),
        i18n.t('months.may'),
        i18n.t('months.june'),
        i18n.t('months.july'),
        i18n.t('months.august'),
        i18n.t('months.september'),
        i18n.t('months.october'),
        i18n.t('months.november'),
        i18n.t('months.december')
      ]

      labels.forEach((label, month) => {
        const monthHasProperty = Object.prototype.hasOwnProperty.call(statistic[year], (month + 1));

        if (monthHasProperty) {
          graphData.push(statistic[year][(month + 1)]);
        } else {
          graphData.push(0);
        }
      });

      return {
        labels: labels,
        datasets: [
          {
            backgroundColor: "#0D2D80",
            data: graphData
          }
        ]
      }
    },
    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        title: {
          scales: {
            xAxes: [{
              gridLines: {
                color: "rgba(0, 0, 0, 0)",
              }
            }]
          }
        },
      }
    },
    statistic() {
      return this.$store.state.ifs.statistic;
    }
  },
  async beforeCreate() {
    await this.$store.dispatch('ifs/listProjects', {
      paginationPage: 0,
      paginationPageSize: 10
    });
    this.loading = false;
  }
}
</script>

<style scoped lang="scss">
#projects-histogram {
  height: 500px;
  width: 500px;
}
</style>